import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import LogoutAccount from './index.vue';

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ProtocolLog = __decorate([Component({
    components: {
      LogoutAccount: LogoutAccount
    }
  })], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;